import Badge from './badge';

/**
 * Thin mapper over the generic Badge for statuses used across the admin:
 * order/fulfillment/sync status, store active/inactive, etc. Statuses are
 * grouped into a small set of color families by type; extend STATUS_CONFIGS
 * by pointing new statuses at an existing family.
 */
const FAMILIES = {
	success: { bgColor: 'bg-white', textColor: 'text-black', border: 'border-black' },
	progress: { bgColor: 'bg-green-600', textColor: 'text-white', border: 'border-green-600' },
	waiting: { bgColor: 'bg-gray-400', textColor: 'text-white', border: 'border-gray-400' },
	neutral: { bgColor: 'bg-gray-300', textColor: 'text-white', border: 'border-gray-300' },
};

// Problem family -- one red hue, shade steps so hold/failed/cancelled stay distinguishable.
const PROBLEM = {
	hold: { bgColor: 'bg-red-600', textColor: 'text-white', border: 'border-red-600' },
	failed: { bgColor: 'bg-red-700', textColor: 'text-white', border: 'border-red-700' },
	cancelled: { bgColor: 'bg-red-900', textColor: 'text-white', border: 'border-red-900' },
};

const STATUS_CONFIGS = {
	active: FAMILIES.success,
	fulfilled: FAMILIES.success,
	shipped: FAMILIES.success,
	processing: FAMILIES.progress,
	// Custom-fulfillment-only orders: handed to the partner, still in flight.
	partner: FAMILIES.progress,
	pending: FAMILIES.waiting,
	approval: FAMILIES.waiting,
	review: FAMILIES.waiting,
	backorder: FAMILIES.waiting,
	...PROBLEM,
	inactive: FAMILIES.neutral,
	unknown: FAMILIES.neutral,
};

const StatusBadge = ({ status, text }) => {
	const key = String(status || 'unknown').toLowerCase();
	const config = STATUS_CONFIGS[key] || STATUS_CONFIGS.unknown;

	return (
		<Badge
			bgColor={config.bgColor}
			textColor={config.textColor}
			border={config.border}
			text={text || status}
		/>
	);
};

export default StatusBadge;
